/* gh-cart-freight.js — fragt-estimat OG antalsvælger i cart-draweren.

   Antalsvælgeren styrer ANTAL BIGBAGS, ikke linjens quantity. Mængden er en
   variant ("5 tons | 2.9m3"), fordi prisen pr. bag afhænger af mængdebåndet —
   og Shopify kan ikke prissætte dynamisk efter quantity uden Plus. Derfor
   bytter + og − linjen til den variant der svarer til det nye antal, i stedet
   for at skrue på quantity. Kunden mærker det ikke: hun ser bare antallet
   stige, prisen pr. bag falde, og fragten følge med.

   En linje med quantity > 1 (fx 2 × "3 tons") normaliseres samtidig til én
   linje med den rigtige variant (6 bags), så mængdebåndet altid rammer rigtigt.


   Al prislogik ligger i window.GHFreight (assets/gh-freight-core.js), som er
   genereret fra checkout-workerens motor. Denne fil oversætter kun kurven til
   fragtgrupper og tegner resultatet.

   Kurven kan indeholde flere fragttyper på én gang — de leveres i hver sin bil
   og betales hver for sig. Derfor vises ÉN linje pr. type plus en samlet total.
   Mængderabatten på bigbag tæller på tværs af materialer, men palle og kran
   hver for sig.

   Postnummeret deles med PDP'en via localStorage ('gh:postnr') og kan rettes
   direkte i kurven. Et nyt postnummer valideres mod kurvens FAKTISKE indhold:
   ligger der løs levering (grab/aftippet) i kurven, afvises postnumre vi ikke
   kører løs levering til, med en begrundelse — i stedet for stiltiende at
   ændre prisen. Opdateres via Dawns cartUpdate-event. */
(function () {
  'use strict';

  var PC_KEY = 'gh:postnr';
  var lastCart = null;

  var LABEL = {
    palle: 'BigBag på palle',
    kran: 'BigBag med kran',
    grab: 'Grab',
    aftippet: 'Aftippet'
  };

  function F() { return window.GHFreight || null; }

  function storedPc() {
    try { return window.localStorage.getItem(PC_KEY) || ''; } catch (e) { return ''; }
  }
  function storePc(pc) {
    try { window.localStorage.setItem(PC_KEY, pc); } catch (e) { /* private mode */ }
  }
  function kr(ore) {
    return Math.round(ore / 100).toLocaleString('da-DK') + ' kr';
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // "4 tons | 2.7m3" → 4 · "2.4 m3" → 4 (bags à 0,6 m³)
  function parseBags(text) {
    var s = String(text || '');
    var t = s.match(/^(\d+)\s*tons?\b/i);
    if (t) return parseInt(t[1], 10);
    var v = s.match(/^(\d+(?:[.,]\d+)?)\s*m3/i);
    if (v) return Math.round(parseFloat(v[1].replace(',', '.')) / 0.6);
    return null;
  }

  /** Kurvens linjer → fragtgrupper. Bags læses af Mængde-optionen, ikke af
   *  vægten: flis vejer kunstigt 1.000 kg pr. bag, og afrunding af gram gav
   *  tidligere forskellige resultater i tema og checkout. */
  function groupsOf(cart) {
    var f = F();
    var groups = f.emptyGroups();
    var unknown = 0;
    (cart.items || []).forEach(function (it) {
      var lev = null, mng = null;
      (it.options_with_values || []).forEach(function (o) {
        if (o.name === 'Levering') lev = o.value;
        if (o.name === 'Mængde') mng = o.value;
      });
      var kind = f.normalizeKind(lev);
      var bags = parseBags(mng);
      if (!kind || !bags) { unknown++; return; }
      groups[kind] += bags * (it.quantity || 1);
    });
    return { groups: groups, unknown: unknown };
  }

  /** Kan kurven overhovedet leveres til dette postnummer?
   *  Løs levering (grab/aftippet) kører kun i vores eget område, så et postnummer
   *  der ellers er fint til bigbag kan være ugyldigt for kurvens indhold. Derfor
   *  valideres mod det der FAKTISK ligger i kurven, ikke mod postnummeret alene. */
  function validateZip(pc, cart) {
    var f = F();
    if (!f) return { ok: true };
    var zone = f.zoneFor(pc);
    if (!zone) return { ok: false, msg: 'Vi leverer ikke til ' + pc + ' endnu.' };

    var g = groupsOf(cart).groups;
    var blocked = ['grab', 'aftippet'].filter(function (k) { return g[k] > 0 && zone.d < 0; });
    if (blocked.length) {
      var navne = blocked.map(function (k) { return LABEL[k]; }).join(' og ');
      return {
        ok: false,
        msg: navne + '-levering kan ikke leveres til ' + pc + ' (' + zone.label
          + '). Løs levering kører vi kun i vores eget område — skift til BigBag '
          + 'i kurven, eller vælg et postnummer vi kører til.'
      };
    }

    var q = f.quote({ zip: pc, groups: g });
    if (!q.ok && q.reason === 'over_max') {
      return {
        ok: false,
        msg: 'Kurven er større end vi kan prissætte online (' + q.bags + ' × '
          + (LABEL[q.kind] || q.kind) + '). Kontakt os, så finder vi en pris.'
      };
    }
    return { ok: true, zone: zone };
  }

  /** Postnummer-feltet bygges ÉN gang og genbruges, så det ikke mister fokus
   *  hver gang prisoversigten nedenunder gentegnes. */
  function ensureBox(footer) {
    var box = footer.querySelector('[data-gh-cart-freight]');
    if (box) return box;
    box = document.createElement('div');
    box.className = 'gh gcf';
    box.setAttribute('data-gh-cart-freight', '');
    box.innerHTML =
      '<div class="gcf-pc">'
      + '<label class="gcf-pc-label" for="gh-cart-pc">Leveres til</label>'
      + '<input id="gh-cart-pc" class="gcf-pc-input" type="text" inputmode="numeric"'
      + ' maxlength="4" placeholder="Postnr." aria-label="Postnummer" data-gh-cart-pc>'
      + '<span class="gcf-pc-zone" data-gh-cart-pc-zone></span>'
      + '</div>'
      + '<p class="gcf-note gcf-warn" data-gh-cart-pc-err hidden></p>'
      + '<div data-gh-breakdown></div>';
    footer.insertBefore(box, footer.firstChild);

    var input = box.querySelector('[data-gh-cart-pc]');
    input.value = storedPc();
    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 4);
      var err = box.querySelector('[data-gh-cart-pc-err]');
      if (input.value.length < 4) {
        err.hidden = true;
        input.classList.remove('is-bad');
        return;
      }
      var v = validateZip(input.value, lastCart || { items: [] });
      if (v.ok) {
        err.hidden = true;
        input.classList.remove('is-bad');
        storePc(input.value);
        refresh();
      } else {
        // Afvist: postnummeret gemmes IKKE, så prisoversigten bliver stående
        // på det sidste gyldige. Feltet beholder det tastede så det kan rettes.
        err.hidden = false;
        err.textContent = v.msg;
        input.classList.add('is-bad');
      }
    });
    return box;
  }

  function render(box, cart) {
    var f = F();
    var pc = storedPc();
    var input = box.querySelector('[data-gh-cart-pc]');
    if (input && document.activeElement !== input && input.value !== pc) input.value = pc;
    var zoneEl = box.querySelector('[data-gh-cart-pc-zone]');
    if (zoneEl) {
      var z = (f && /^\d{4}$/.test(pc)) ? f.zoneFor(pc) : null;
      zoneEl.textContent = z ? z.label : '';
    }
    var html = '<div class="gcf-row gcf-mat"><span>Materialepris</span><b>'
      + kr(cart.total_price) + '</b></div>';
    var freightOre = 0;
    var known = false;

    if (!f) {
      html += '<p class="gcf-note">Fragt beregnes i kassen.</p>';
    } else if (!/^\d{4}$/.test(pc)) {
      html += '<p class="gcf-note">Indtast dit postnummer ovenfor, så viser vi fragten.</p>';
    } else {
      var g = groupsOf(cart);
      var q = f.quote({ zip: pc, groups: g.groups });
      if (g.unknown) {
        html += '<p class="gcf-note">Fragt beregnes i kassen.</p>';
      } else if (!q.ok && q.reason === 'no_zone') {
        html += '<p class="gcf-note gcf-warn">Vi leverer desværre ikke til ' + esc(pc) + ' endnu.</p>';
      } else if (!q.ok && q.reason === 'no_distance') {
        html += '<p class="gcf-note gcf-warn">' + esc(LABEL[q.kind] || 'Løs levering')
          + ' kan ikke leveres til ' + esc(pc) + '. Vælg BigBag i stedet.</p>';
      } else if (!q.ok && q.reason === 'over_max') {
        html += '<p class="gcf-note gcf-warn">Kurven er større end vi kan prissætte online ('
          + q.bags + ' × ' + esc(LABEL[q.kind] || q.kind) + '). Kontakt os, så finder vi en pris.</p>';
      } else if (q.ok) {
        known = true;
        freightOre = q.totalOre;
        q.parts.forEach(function (p) {
          var detail = p.unit === 'stk' ? p.bags + ' stk' : 'ét læs';
          html += '<div class="gcf-row"><span>' + esc(LABEL[p.kind]) + ' <em>(' + detail + ')</em></span><b>'
            + kr(p.ore) + '</b></div>';
        });
        if (q.parts.length > 1) {
          html += '<div class="gcf-row gcf-sub"><span>Fragt i alt</span><b>' + kr(q.totalOre) + '</b></div>';
        }
        // Tabellen er ikke-monoton: én bag mere kan gøre den samlede fragt
        // billigere. Vis det som en mulighed, ikke som et minustal.
        q.parts.forEach(function (p) {
          if (p.unit !== 'stk') return;
          var c = f.cheaperAbove(p.kind, p.bags, q.zone);
          if (!c || c.saveOre <= 0) return;
          var extra = c.atBags - p.bags;
          html += '<p class="gcf-note gcf-tip">Læg ' + extra + ' '
            + (extra === 1 ? 'bigbag' : 'bigbags') + ' mere i kurven ('
            + esc(LABEL[p.kind].toLowerCase()) + ') og spar ' + kr(c.saveOre) + ' i fragt.</p>';
        });
      } else {
        html += '<p class="gcf-note">Fragt beregnes i kassen.</p>';
      }
    }

    html += '<div class="gcf-row gcf-total"><span>Estimeret totalbeløb</span><b>'
      + kr(cart.total_price + freightOre) + '</b></div>';
    box.querySelector('[data-gh-breakdown]').innerHTML = html;
    updateTotal(cart, known ? freightOre : 0);
  }

  /* Dawns egen total nederst opdateres til materialer + fragt. Skriv kun ved
     ændring — ellers kan vi trigge vores eget refresh igen. */
  function updateTotal(cart, freightOre) {
    var el = document.querySelector('cart-drawer .totals__total-value');
    if (!el) return;
    var txt = kr(cart.total_price + freightOre);
    if (el.textContent !== txt) el.textContent = txt;
  }

  // ------------------------------------------------------- antalsvælger

  var productCache = {};
  var busy = false;

  /** Produktets varianter — til at finde den variant der matcher et antal bags. */
  function loadProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js', {
      headers: { Accept: 'application/json' }, cache: 'no-store'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }

  /** Variant på (antal bags, fragttype) i et produkt. null hvis den ikke findes. */
  function variantFor(product, bags, kind) {
    var f = F();
    if (!product || !f) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (parseBags(v.option1) !== bags) continue;
      if (f.normalizeKind(v.option2) === kind) return v;
    }
    return null;
  }

  /** Byt linjen til varianten for `bags`. Fjern + tilføj, så line-properties
   *  (_gh_kind/_gh_bags) følger med — /cart/change.js kan ikke skifte variant. */
  function setBags(item, kind, bags) {
    if (busy) return;
    busy = true;
    loadProduct(item.handle)
      .then(function (product) {
        var v = variantFor(product, bags, kind);
        if (!v || !v.available) throw new Error('ingen variant');
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        }).then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: v.id,
              quantity: 1,
              properties: { _gh_kind: kind, _gh_bags: bags },
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          });
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        applySections(data.sections);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gh-cart-qty' });
        }
      })
      .catch(function () { /* uændret kurv — brugeren kan prøve igen */ })
      .finally(function () { busy = false; refresh(); });
  }

  function applySections(sections) {
    if (!sections) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var fresh = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html')
        .querySelector('cart-drawer');
      if (fresh) {
        drawer.innerHTML = fresh.innerHTML;
        drawer.classList.toggle('is-empty', !fresh.querySelector('.cart-item'));
      }
    }
  }

  /** Erstat Dawns quantity-stepper med en der tæller BIGBAGS.
   *  <quantity-input> udskiftes helt, så Dawns egne lyttere ikke også fyrer. */
  function decorateQuantities(cart) {
    var f = F();
    if (!f) return;
    (cart.items || []).forEach(function (item, i) {
      var row = document.querySelector('#CartDrawer-Item-' + (i + 1))
        || document.querySelector('#CartItem-' + (i + 1));
      if (!row) return;
      var qi = row.querySelector('quantity-input');
      if (!qi || qi.dataset.ghQty === '1') return;

      var lev = null, mng = null;
      (item.options_with_values || []).forEach(function (o) {
        if (o.name === 'Levering') lev = o.value;
        if (o.name === 'Mængde') mng = o.value;
      });
      var kind = f.normalizeKind(lev);
      var unit = parseBags(mng);
      if (!kind || !unit) return;             // fx "Kontakt os"-varianter
      var bags = unit * (item.quantity || 1);

      var minus = qi.querySelector('[name="minus"]');
      var plus = qi.querySelector('[name="plus"]');
      var box = document.createElement('div');
      box.className = qi.className + ' gh-qty';
      box.dataset.ghQty = '1';
      box.innerHTML =
        '<button type="button" class="quantity__button" data-gh-cart-step="-1"'
        + (bags <= 1 ? ' disabled' : '') + '>'
        + (minus ? minus.innerHTML : '&minus;') + '</button>'
        + '<input class="quantity__input" type="text" inputmode="numeric" value="' + bags
        + '" aria-label="Antal bigbags" data-gh-cart-qty>'
        + '<button type="button" class="quantity__button" data-gh-cart-step="1"'
        + (bags >= f.maxBags ? ' disabled' : '') + '>'
        + (plus ? plus.innerHTML : '+') + '</button>';

      box.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gh-cart-step]');
        if (!btn || btn.disabled) return;
        var next = bags + parseInt(btn.dataset.ghCartStep, 10);
        if (next < 1 || next > f.maxBags) return;
        box.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
        setBags(item, kind, next);
      });
      box.addEventListener('change', function (e) {
        var el = e.target.closest('[data-gh-cart-qty]');
        if (!el) return;
        var next = Math.max(1, Math.min(f.maxBags, parseInt(el.value, 10) || bags));
        if (next === bags) { el.value = bags; return; }
        setBags(item, kind, next);
      });

      qi.replaceWith(box);
    });
  }

  var refreshing = false;

  function refresh() {
    var footer = document.querySelector('cart-drawer .drawer__footer');
    var hasLines = document.querySelector('.cart-item');
    if (refreshing || (!footer && !hasLines)) return;
    refreshing = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        lastCart = cart;
        var box = footer ? footer.querySelector('[data-gh-cart-freight]') : null;
        if (!cart.items || !cart.items.length) {
          if (box) box.remove();
          return;
        }
        if (footer) render(ensureBox(footer), cart);
        // Antalsvælgeren skal også virke på /cart-siden, hvor der ingen
        // drawer-footer er at hænge fragtboksen op i.
        decorateQuantities(cart);
      })
      .catch(function () { /* draweren viser bare Dawns egen total */ })
      .finally(function () { refreshing = false; });
  }

  function start() {
    refresh();
    // Dawn publisher cartUpdate ved enhver mængdeændring i drawer og /cart.
    // Det afløser den MutationObserver der før holdt boksen i live.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 0); });
    }
    // Draweren renderes først når den åbnes.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#cart-icon-bubble')) setTimeout(refresh, 150);
    });
    document.addEventListener('shopify:section:load', refresh);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
